'use client';

import Link from 'next/link';
import { AUDIO_TOOL_EVENT_KEYS } from '../../lib/audioToolEventKeys';

export default function FreeAudioToolLink({ href, toolId, children }) {
  return <Link className="audio-tool-card-action" href={href} onClick={() => {
    const params = { tool_id: toolId, tool_key: AUDIO_TOOL_EVENT_KEYS[toolId] || 'unknown' };
    for (const event of ['audio_tool_card_click', `audio_tool_open_${params.tool_key}`]) {
      window.dispatchEvent(new CustomEvent('track', { detail: { event, params } }));
    }
  }}>{children}</Link>;
}
